module.exports = __webpack_public_path__ + "img/procreate.8901aaa.png";